import { Box, Button, Input, Typography } from '@mui/material'
import { useCallback } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { DndContainer } from './components'
import { styles } from './styles'
import type { UploadFilesProps } from './types'

export const UploadFiles = (props: UploadFilesProps) => {
  const {
    styles: customStyles,
    name,
    label = 'Перетащите сюда сертификат проверки или выберите его на вашем компьютере',
    setNewFiles,
  } = props

  const { control } = useFormContext()

  const { append } = useFieldArray({
    control,
    name,
  })

  const onFileDrop = useCallback((files: File[]) => {
    if (!files) return

    const allowedFileTypes = [
      'application/pdf',
      'image/jpg',
      'image/jpeg',
      'image/png',
      'image/tiff',
      'image/bmp',
    ]

    const maxFileSize = 5 * 1024 * 1024 // 5 MB

    const filteredFiles = files.filter((file) => {
      const isTypeAllowed = allowedFileTypes.includes(file.type)
      const isSizeAllowed = file.size <= maxFileSize
      return isTypeAllowed && isSizeAllowed
    })

    if (filteredFiles.length > 0) {
      append(Array.from(filteredFiles))
      setNewFiles(filteredFiles)
    } else {
      console.error(
        'Недопустимый тип файла или размер превышает 5 МБ. Выберите файл PDF, JPG, PNG, TIFF или BMP.'
      )
      alert(
        'Размер превышает 5 МБ или недопустимый тип файла. Выберите файл PDF, JPG, PNG, TIFF или BMP.'
      )
    }
  }, [])

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null
    if (!file) {
      return
    }
    onFileDrop([file])
  }

  return (
    <Box sx={{ ...styles.root, ...customStyles }}>
      <DndContainer onDrop={onFileDrop}>
        <Box className={'uploadFiles__drop-zone'}>
          <Typography mb={2} fontWeight={500}>
            {label}
          </Typography>
          <Button
            component="label"
            className={'uploadFiles__trigger-btn'}
            variant={'outlined'}
          >
            Добавить файл
            <Input
              onChange={onChange}
              className={'uploadFiles__upload-input'}
              type="file"
              inputProps={{ accept: '.pdf, .jpg, .jpeg, .png, .tiff, .bmp' }}
            />
          </Button>
        </Box>
      </DndContainer>
    </Box>
  )
}
